/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDto
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDto {
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDto
     */
    Account: FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDto
     */
    Track: FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDto
     */
    Features: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDto interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDto(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDto {
    if (!('Account' in value) || value['Account'] === undefined) return false;
    if (!('Track' in value) || value['Track'] === undefined) return false;
    if (!('Features' in value) || value['Features'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDto {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Account': FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSON(json['account']),
        'Track': FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSON(json['track']),
        'Features': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON(json['features']),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDto {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account': FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSON(value['Account']),
        'track': FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSON(value['Track']),
        'features': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON(value['Features']),
    };
}

